import React, { useEffect, useState } from 'react'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import '../SettingsViews/SettingsListView.scss'
import '../Fiscal/ReceiptItemToFilingType.scss'
import { CheckboxList } from '../SettingsViews/SettingsComponents/CheckboxList'
import { GET_ACTIVE_BASIC_LOOKUP_TYPES } from '../../../requests'
import { useRequestData } from '../../../Utilities/hooks'
import { ContextButton } from '@tecuity/granite-ui'
import Revert from '@tecuity/sos-icons/react/revert'
import RightArrow from '@tecuity/sos-icons/react/right-arrow'
import * as api from '../../../requests'
import { SET_SETTINGS_LIST, SET_OPTIONAL_DATA } from '../SettingsReducer'
import { setErrorToast, setSuccessToast } from '../../../actions'
import { Spinner } from '../../Loaders/Loaders'
import BusinessRecordSubTypeToRecordTypeOptions from '../SettingsViews/Options/BusinessRecordSubTypeToRecordTypeOptions'

const BusinessRecordTypeSubTypeXref = () => {
  const dispatch = useDispatch()
  const { optionalData, settingsList } = useSelector((state) => state.settings, shallowEqual)
  const { recordType = 0 } = optionalData
  const recordSubTypes = useRequestData(
    (cb, errCb) =>
      GET_ACTIVE_BASIC_LOOKUP_TYPES(
        'Business',
        'RecordSubType',
        (res) => {
          cb([...res.sort((a, b) => (a.Name > b.Name ? 1 : -1))])
        },
        errCb
      ),
    [],
    []
  )
  const [checkedTypes, setCheckedTypes] = useState(settingsList.BusinessRecordSubTypeIds || [])
  const [isDirty, setIsDirty] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setCheckedTypes(settingsList.BusinessRecordSubTypeIds || [])
    setIsDirty(false)
  }, [settingsList.BusinessRecordSubTypeIds])

  useEffect(() => {
    return () => {
      dispatch({ type: SET_SETTINGS_LIST, settingsList: [] })
    }
  }, [])

  const clickRevert = () => {
    setLoading(true)
    api.GET_BUSINESS_RECORD_SUB_TYPE_XREFS_BY_RECORD_TYPE(
      recordType,
      (res) => {
        dispatch({ type: SET_SETTINGS_LIST, settingsList: res })
        dispatch({ type: SET_OPTIONAL_DATA, optionalData: { recordType } })
        setLoading(false)
      },
      (err) => {
        console.error('retrieving', err)
        setLoading(false)
      }
    )
  }

  const clickSave = () => {
    setLoading(true)
    api.SAVE_SETTINGS_BUSINESS_RECORD_SUB_TYPE_XREF(
      { ...settingsList, BusinessRecordSubTypeIds: [...checkedTypes] },
      (res) => {
        clickRevert()
        dispatch(setSuccessToast('Successfully saved XRef'))
      },
      (err) => {
        console.error(err)
        dispatch(setErrorToast('Failed to save XRef'))
        setLoading(false)
      }
    )
  }

  return (
    <div className="settings-list-view">
      <h2>Business Record Sub Types To Record Type</h2>
      <BusinessRecordSubTypeToRecordTypeOptions />
      <div className="content-column-direction">
        <CheckboxList
          allowShowOnlyChecked
          checkListOnly
          label="Business Record Sub Types"
          items={recordSubTypes.map((type) => {
            return {
              label: `${type.Name}`, // - ${type.IsActive ? 'Active' : 'Inactive'}`,
              id: type.Id,
            }
          })}
          checkedList={checkedTypes || []}
          setActiveChanges={(newTypes) => {
            setCheckedTypes(newTypes)
            setIsDirty(true)
          }}
        />
        <div className="button-wrapper">
          {loading && (
            <div className="loading-type">
              <Spinner size="small" themeColor="dark-neutral" />
            </div>
          )}
          <ContextButton
            variant="danger"
            disabled={!isDirty}
            leftIcon={
              <div className="checkmark-wrapper left">
                <Revert />
              </div>
            }
            onClick={clickRevert}
          >
            Revert
          </ContextButton>
          <ContextButton
            variant="primary"
            disabled={!isDirty}
            rightIcon={
              <div className="checkmark-wrapper right">
                <RightArrow />
              </div>
            }
            onClick={clickSave}
          >
            Save
          </ContextButton>
        </div>
      </div>
    </div>
  )
}

export default BusinessRecordTypeSubTypeXref
